import { HttpClient } from '../../httpClient'
import {
  OpalApiRequestBody,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type Params = OpalApiRequestParams<'UpdateMomentCustomFieldV3'>
type RequestBody = OpalApiRequestBody<'UpdateMomentCustomFieldV3'>
type Response = OpalApiResponseDocument<'UpdateMomentCustomFieldV3', 200>

export function updateMomentCustomField({
  params,
  requestBody,
}: {
  params: Params
  requestBody: RequestBody
}): Promise<Response> {
  const url = new URL(
    `/moments/v3/${params.path.moment_id}/moment_custom_fields/${params.path.moment_custom_field_id}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
